import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { getWhatsAppUrl } from '../utils/whatsapp';
export const FloatingWhatsApp = () => {
  const {
    t
  } = useLanguage();
  const handleClick = () => {
    const message = t('wa.help');
    window.open(getWhatsAppUrl(message), '_blank');
  };
  return <div className="fixed bottom-6 right-6 z-50 group" data-id="element-174">
      {/* Pulsing rings */}
      <motion.span aria-hidden className="absolute inset-0 rounded-full bg-[#25D366]" animate={{
      scale: [1, 1.6],
      opacity: [0.5, 0]
    }} transition={{
      duration: 1.8,
      repeat: Infinity,
      ease: 'easeOut'
    }} data-id="element-175" />
      <motion.span aria-hidden className="absolute inset-0 rounded-full bg-[#25D366]" animate={{
      scale: [1, 1.6],
      opacity: [0.4, 0]
    }} transition={{
      duration: 1.8,
      repeat: Infinity,
      ease: 'easeOut',
      delay: 0.9
    }} data-id="element-176" />

      {/* Sparkle / shimmer overlay */}
      <motion.span aria-hidden className="absolute -top-1 -left-1 w-3 h-3 rounded-full bg-white" animate={{
      opacity: [0, 1, 0],
      scale: [0.6, 1.4, 0.6]
    }} transition={{
      duration: 2.2,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-177" />
      <motion.span aria-hidden className="absolute -bottom-1 -right-1 w-2.5 h-2.5 rounded-full bg-white" animate={{
      opacity: [0, 1, 0],
      scale: [0.5, 1.3, 0.5]
    }} transition={{
      duration: 2.4,
      repeat: Infinity,
      ease: 'easeInOut',
      delay: 0.6
    }} data-id="element-178" />

      <motion.button onClick={handleClick} className="relative bg-[#25D366] hover:bg-[#128C7E] text-white p-4 rounded-full shadow-2xl shadow-[#25D366]/50 flex items-center justify-center" aria-label="Contact on WhatsApp" animate={{
      boxShadow: ['0 0 0 0 rgba(37,211,102,0.7)', '0 0 0 18px rgba(37,211,102,0)', '0 0 0 0 rgba(37,211,102,0)']
    }} transition={{
      duration: 2.2,
      repeat: Infinity,
      ease: 'easeOut'
    }} whileHover={{
      scale: 1.1,
      rotate: -6
    }} data-id="element-179">
        <MessageCircle className="w-8 h-8" data-id="element-180" />
      </motion.button>

      {/* Tooltip */}
      <span className="absolute right-full top-1/2 -translate-y-1/2 mr-4 bg-white text-navy px-4 py-2 rounded-lg shadow-lg text-sm font-bold whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none" data-id="element-181">
        {t('header.reserve')}
      </span>
    </div>;
};